<template>
  <div class="ch_bussiness">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'中文台资询台'},{name:'中文台资讯台业务'}]"></breadcrumb>
    <div class="ch_bussiness-wrap">
      <div class="ch_bussiness-contain">
        <ch-top-nav>
          <el-button @click="addOrganization()"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">新增单位</span>
          </el-button>
        </ch-top-nav>
        <div class="ch_bussiness-search_wrap">
          <div class="ch_bussiness-search_top">
            <div class="ch_bussiness-search_left">
              <el-select clearable
                         @change="searchChange()"
                         placeholder="全部省份"
                         v-model="params.provid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
              <el-select clearable
                         @change="searchTypeChange()"
                         placeholder="全部类别"
                         v-model="params.type">
                <el-option v-for="(item,index) in typeList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
              <el-select clearable
                         @change="searchChange()"
                         placeholder="全部级别"
                         v-model="params.level">
                <el-option v-for="item in searchLevelList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="ch_bussiness-search_right">
              <a class="ch_bussiness-table_download"
                 @click="exportExcel()">
                <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                   :icon="['fas', 'level-up-alt']" />导出Excel</a>
              <el-input prefix-icon="el-icon-search"
                        v-model="params.name"
                        @keyup.enter.native="searchChange()"
                        placeholder="输入内容回车搜索"></el-input>
            </div>
          </div>
          <div class="ch_bussiness-more">
            <div class="ch_bussiness-more_search"
                 v-show="searchShow">
              <el-form label-position="top">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="整合情况">
                      <el-select clearable
                                 @change="searchChange()"
                                 placeholder="不限"
                                 v-model="params.intergration">
                        <el-option v-for="item in intergrationList"
                                   :key="item.code"
                                   :label="item.desc"
                                   :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="网络户数大于">
                      <el-input clearable
                                @keyup.enter.native="searchChange()"
                                v-model="params.amount"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="许可证">
                      <el-select clearable
                                 v-model="params.license"
                                 @change="searchChange()">
                        <el-option label="不限"
                                   value></el-option>
                        <el-option label="有"
                                   value="0"></el-option>
                        <el-option label="无"
                                   value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="资讯台户数大于">
                      <el-input clearable
                                v-model="params.informationNumber"
                                @keyup.enter.native="searchChange()"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="中文台户数大于">
                      <el-input clearable
                                v-model="params.number"
                                @keyup.enter.native="searchChange()"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row></el-row>
              </el-form>
            </div>
            <div @click="searchShow=!searchShow"
                 class="ch_bussiness-more_button">高级筛选
              <font-awesome-icon v-if="!searchShow"
                                 style="color:#96A6B8;margin-left:10px"
                                 :icon="['fas', 'angle-double-down']" />
              <font-awesome-icon v-else
                                 style="color:#F0722B;margin-left:10px"
                                 :icon="['fas', 'angle-double-up']" />
            </div>
          </div>
        </div>
        <div class="ch_bussiness-table-wrap">
          <div class="ch_bussiness-table_title">符合条件记录
            <span>{{clientNum}}</span> 条<br/>中文台
            <span>{{chinaNum}}万户，</span>其中
            <span>{{chinaIncludeNum}}</span>万户含在上级网中，实际有效用户
            <span>{{(chinaNum-chinaIncludeNum).toFixed(2)}}</span>万户<br/>资讯台
            <span>{{informNum}}万户，</span>其中
            <span>{{informIncludeNum}}</span>万户含在上级网中，实际有效用户
            <span>{{(informNum-informIncludeNum).toFixed(2)}}</span>万户</div>
          <div class="ch_bussiness-table">
            <table>
              <tr>
                <th>单位</th>
                <th>省</th>
                <th>市</th>
                <th>区</th>
                <th>类别</th>
                <th>级别</th>
                <th>中文台户数</th>
                <th>是否包含</th>
                <th>资讯台户数</th>
                <th>是否包含</th>
                <th>添加日期</th>
              </tr>
              <tr v-for="item in clientsList"
                  :key="item.cid">
                <td>
                  <a @click="gotoDetail(item.cid)">{{item.cunitsname}}</a>
                </td>
                <td>{{item.providName}}</td>
                <td>{{item.cityidName}}</td>
                <td>{{item.countyName}}</td>
                <td>{{item.typeName}}</td>
                <td>{{item.levelName}}</td>
                <td>{{item.clientSum}}</td>
                <td>{{item.clientInclude?'是':(item.clientInclude===0?'否':'')}}</td>
                <td>{{item.informationSum}}</td>
                <td>{{item.informationInclude?'是':(item.informationInclude===0?'否':'')}}</td>
                <td>{{(item.updateTime||item.createTime||'').split('T')[0]}}</td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="Number(params.page)"
                         class="ch_bussiness-pagination"
                         background
                         layout="prev, pager, next"
                         :total="listSize"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog with="740px"
               :close-on-click-modal="false"
               class="ch_bussiness-dialog"
               title="添加新单位"
               :visible.sync="showForm">
      <el-form label-position="top"
               class="ch_bussiness-form">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="单位">
              <el-input v-model="clientForm.cunitsname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="类别">
              <el-select @change="typeChange"
                         v-model="clientForm.ctype">
                <el-option v-for="(item,index) in typeList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="级别">
              <el-select v-model="clientForm.clevel">
                <el-option v-for="item in levelList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="ch_bussiness-checkbox">
              <el-checkbox v-model="clientForm.cadvip">广告客户</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="4">
            <el-form-item label="省">
              <el-select @change="providChange"
                         v-model="clientForm.cprovid">
                <el-option v-for="(item,index) in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="市">
              <el-select @change="cityChange"
                         v-model="clientForm.ccityid">
                <el-option v-for="(item,index) in cityList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="区">
              <el-select v-model="clientForm.ccounty">
                <el-option v-for="item in countyList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="clientForm.caddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="用户主要覆盖区域">
              <el-select v-model="clientForm.carea">
                <el-option v-for="item in areaTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整合情况信号来源">
              <el-select v-model="clientForm.cintergration">
                <el-option v-for="item in intergrationList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="全网户数">
              <el-input v-model="clientForm.camount"></el-input>
            </el-form-item>
          </el-col>
          </el-col>
          <el-col :span="12">
            <div class="ch_bussiness-checkbox">
              <el-checkbox v-model="clientForm.isSevendaysMove">是否支持7天时移</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="5"
                      v-model="clientForm.cmemo"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="dialogLoading"
                   @click="addClient()">提 交</el-button>
        <el-button @click="showForm = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import chTopNav from '@/components/chTopNav'
import _ from 'lodash'
export default {
  components: {
    breadcrumb,
    chTopNav
  },
  data() {
    return {
      clientNum: '',
      informNum: '',
      informIncludeNum: '',
      chinaNum: '',
      chinaIncludeNum: '',
      dialogLoading: false,
      listSize: 0,
      searchDate: '',
      clientsList: [],
      searchLevelList: [],
      // startTime: "",
      // endTime: "",
      showForm: false,
      clientForm: {
        caddress: '',
        cadvip: false,
        camount: '',
        carea: '',
        ccityid: '',
        ccounty: '',
        isSevendaysMove: false,
        cintergration: '',
        clevel: '',
        cmemo: '',
        cprovid: '',
        ctype: '',
        cunitsname: ''
      },
      typeList: [],
      intergrationList: [],
      areaTypeList: [],
      levelList: [],
      providList: [],
      cityList: [],
      countyList: [],
      params: {
        name: '',
        page: '',
        type: '',
        provid: '',
        intergration: '',
        amount: '',
        number: '',
        informationNumber: '',
        pageSize: 10,
        license: '',
        level: ''
      },
      searchShow: false
    }
  },
  created(){
    this.params = {
        name: '',
        page: this.$route.query.page?this.$route.query.page:1,
        type: '',
        provid: '',
        intergration: '',
        amount: '',
        number: '',
        informationNumber: '',
        pageSize: 10,
        license: '',
        level: ''
      }

  },
  mounted() {
    this.getSelectList().then(res => {
      if (Object.keys(this.$route.query).length) {
        console.log(this.$route.query)
        this.params = _.cloneDeep(this.$route.query)

        this.params.provid = this.params.provid
          ? Number(this.params.provid)
          : ''
        this.params.type = this.params.type ? Number(this.params.type) : ''
        this.params.level = this.params.level ? Number(this.params.level) : ''
        this.params.intergration = this.params.intergration
          ? Number(this.params.intergration)
          : ''
        this.params.amount = this.params.amount
          ? Number(this.params.amount)
          : ''
        this.params.number = this.params.number
          ? Number(this.params.number)
          : ''
        this.params.informationNumber = this.params.informationNumber
          ? Number(this.params.informationNumber)
          : ''
        this.params.pageSize = this.params.pageSize
          ? Number(this.params.pageSize)
          : ''
        this.params.license = this.params.license
          ? Number(this.params.license)
          : ''
        this.params.page = Number(this.params.page)
      }
      if (this.params.type === '') {
        this.searchLevelList = []
      } else {
        let index = this.params.type
        this.searchLevelList = this.typeList[index].children
      }
      this.getList()
    })
  },

  methods: {
    //加载添加单位Form种的下拉框
    getSelectList() {
      return Promise.all([
        //获取类别--级别
        axios.get(api.clientCategory).then(res => {
          if (res.data.code === 0) {
            console.log('获取类型--级别列表成功', res.data.result)
            this.typeList = res.data.result
          } else {
            console.log('获取类型--级别列表失败', res.data.msg)
          }
        }),
        //获取信号来源列表
        axios.get(api.getIntergrationTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取信号来源列表成功', res.data.result)
            this.intergrationList = res.data.result
          } else {
            console.log('获取信号来源列表失败', res.data.msg)
          }
        }),
        //获取覆盖区域列表
        axios.get(api.getAreaTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取覆盖区域列表成功', res.data.result)
            this.areaTypeList = res.data.result
          } else {
            console.log('获取覆盖区域列表失败', res.data.msg)
          }
        }),
        //获取省-市-区列表
        axios.post(api.areaListAuth).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，稍后重试')
        })
    },
    //添加单位
    addOrganization() {
      ;(this.clientForm = {
        caddress: '',
        cadvip: false,
        camount: '',
        carea: '',
        ccityid: '',
        ccounty: '',
        isSevendaysMove: false,
        cintergration: '',
        clevel: '',
        cmemo: '',
        cprovid: '',
        ctype: '',
        cunitsname: ''
      }),
        (this.showForm = true)
    },
    getList() {
      let params = _.cloneDeep(this.params)
      params.type =
        this.params.type !== '' ? this.typeList[this.params.type].id : ''
      axios
        .post(api.clientsList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取中文台客户资料列表成功', res.data.result)
            this.clientNum = res.data.result.clientNum
            this.informNum = res.data.result.informNum
            this.informIncludeNum = res.data.result.informIncludeNum
            this.chinaNum = res.data.result.chinaNum
            this.chinaIncludeNum = res.data.result.chinaIncludeNum
            this.clientsList = res.data.result.pageResult.records
            this.listSize = res.data.result.pageResult.total
          } else {
            console.log('获取中文台客户资料列表失败', res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    changePage(v) {
      this.params.page = v
      this.$router.replace({
        path: '/ch_channel/bussiness',
        query: this.params
      })
      this.getList()
    },

    gotoDetail(id) {
      this.$router.push({
        path: `/ch_channel/detail/${id}`,
        query: { from: 'bussiness' }
      })
    },
    //类别改变
    typeChange() {
      if (this.clientForm.ctype === '') {
        this.levelList = []
      } else {
        let index = this.clientForm.ctype
        this.levelList = this.typeList[index].children
      }
    },
    //搜索类别改变
    searchTypeChange() {
      if (this.params.type === '') {
        this.searchLevelList = []
      } else {
        let index = this.params.type
        this.searchLevelList = this.typeList[index].children
      }
      this.searchChange()
    },
    //省改变
    providChange() {
      let index = this.clientForm.cprovid
      this.cityList = this.providList[index].children
    },
    //市改变
    cityChange() {
      let index = this.clientForm.ccityid
      this.countyList = this.cityList[index].children
    },
    //添加单位
    addClient() {
      this.dialogLoading = true
      let params = _.cloneDeep(this.clientForm)
      params.ctype = this.typeList[this.clientForm.ctype].id
      params.cprovid = this.providList[this.clientForm.cprovid].id
      params.ccityid = this.cityList[this.clientForm.ccityid].id
      params.isSevendaysMove = Number(this.clientForm.isSevendaysMove)
      params.cadvip = Number(this.clientForm.cadvip)
      console.log('添加单位参数', params)
      axios
        .post(api.addClientClients, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '添加单位成功',
              type: 'success'
            })
            this.showForm = false
            this.dialogLoading = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
            this.dialogLoading = false
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
          this.dialogLoading = false
        })
    },
    //搜索条件改变
    searchChange() {
      this.params.page = 1
      this.$router.replace({
        path: '/ch_channel/bussiness',
        query: this.params
      })
      this.getList()
    },
    //导出excel
    exportExcel() {
      axios({
        // 用axios发送post请求
        method: 'post',
        url: api.clientExport,
        data: this.params,
        responseType: 'blob' // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '中文台列表.xls'
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    }
  }
}
</script>

<style lang="scss">
.ch_bussiness {
  min-width: 1255px;
  .ch_bussiness-wrap {
    padding: 77px 30px 0px 30px;
    .ch_bussiness-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .ch_bussiness-search_wrap {
        position: relative;
        .ch_bussiness-search_top {
          background: #f8f8f8;
          padding: 20px 27px;
          display: flex;
          .ch_bussiness-search_left {
            display: flex;
            flex: 1;
            .el-select {
              width: 120px;
              margin-right: 13px;
            }
          }
          .ch_bussiness-search_right {
            display: flex;
            .ch_bussiness-table_download {
              cursor: pointer;
              text-decoration: none;
              cursor: pointer;
              width: 108px;
              height: 38px;
              border-radius: 4px;
              background: #fff;
              margin-right: 10px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 38px;
              text-align: center;
            }
            .el-input {
              width: 178px;
            }
          }
        }
        .ch_bussiness-more {
          position: absolute;
          width: 100%;
          .ch_bussiness-more_search {
            padding: 18px 29px 29px 29px;
            background: #f8f8f8;
            border-top: 1px solid rgba(230, 227, 227, 1);
            .el-select {
              width: 100%;
            }
          }
          .ch_bussiness-more_button {
            height: 36px;
            line-height: 36px;
            color: #9b9b9b;
            border: 1px solid rgba(233, 233, 233, 1);
            border-right: 0px;
            border-left: 0px;
            text-align: center;
            background: #fff;
            cursor: pointer;
          }
        }
      }

      .ch_bussiness-table-wrap {
        padding: 68px 30px 30px 30px;
        z-index: 1000;
        .ch_bussiness-table_title {
          color: #9b9b9b;
          span {
            color: #f0722b;
          }
        }
        .ch_bussiness-table {
          min-height: 470px;
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .ch_bussiness-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .ch_bussiness-dialog {
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }

    .ch_bussiness-form {
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
      }
      .ch_bussiness-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
}
</style>
